import React, { useState, useCallback, useEffect, useRef } from "react";
import Label from "components/general/Label"
import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Competitor from "components/presentation/Competitor";
import Noc from "components/presentation/Noc";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheck, faStop
} from "@fortawesome/free-solid-svg-icons";

import { usePrevious } from "./common"

export function CompetitorBlockNoData(competitor) {
    return (
        <div className='score-competitor-container  d-flex flex-row justify-content-start'>
            <div className='score-name'>{competitor?.cp_code} </div>
        </div>
    )
}

export function Footer({ data }) {

    const locationCode = data?.schedule?.location?.code;
    const className = locationCode === 'FEB' ? 'text-primary' : locationCode === 'FER' ? 'text-danger' : locationCode === 'FEG' ? 'text-success' : 'text-warning'
    const piste = (<FontAwesomeIcon className={className} icon={faStop} />)

    const formatDate = Label({ data: 'BracketDateFormat' });
    const formatDateTime = Label({ data: 'BracketDateTimeFormat' });

    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} />, TDB</>
    const time = data?.bi_time && <DateTime datetime={dateTime} format={"HH:mm"} />
    const dateComponent = data?.bi_time ? dateTimeFormated : date
    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status'>{data?.result?.status?.code}</div>}
            {isLessLiveStatus(data?.result?.status?.code) && (<div className='d-flex justify-content-between'><div className='text-start'>{dateComponent}</div><div className='text-end'>{data?.schedule?.location?.description} {piste}</div></div>)}

        </>
    )
}

export function CompetitorBlock(competitor) {
    //console.log(competitor)
    return (
        <div className='score-competitor-container  d-flex flex-row justify-content-start'>
            {/*<div className='score-uniform score-uniform-home'></div>*/}
            <div className='score-noc'>
                <Noc className='me-1' {...competitor?.participant?.organisation} />
            </div>
            <div className='score-name'><Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} showSeed={true} seed={competitor?.co_seed} /> </div>
        </div>
    )
}
